function VotesAndFavorites() {
  return (
    <div>VotesAndFavorites</div>
  )
}

export default VotesAndFavorites